export default "__VITE_ASSET__CGzoiPD4__"